import { createContext, Dispatch, ReactNode, SetStateAction } from 'react';

type Banners = Record<string, ReactNode>;

type LayoutContextType = {
  layout: { title: string };
  setLayout: Dispatch<SetStateAction<{ title: string }>>;
  banners: Banners;
  setBanner: (key: string, banner: ReactNode | null) => void;
};

export const LayoutContext = createContext<LayoutContextType>({
  layout: { title: '' },
  // no-dd-sa:typescript-best-practices/no-empty
  setLayout: () => {},
  banners: {},
  // no-dd-sa:typescript-best-practices/no-empty
  setBanner: () => {},
});
